<template>
    <div>
        <a-row>
            <a-col :span="24" style="margin-bottom: 10px;border-bottom: 1px solid #f0f2f5;">
                <a-row type="flex" justify="start">
                    <a-col :span="20" :style="{textAlign: 'left',padding: '10px 0 0 20px'}">
                        <span style="font-size: 1.6em;">添加文章标签</span>
                    </a-col>
                    <a-col :span="4" :style="{textAlign: 'right', padding: '10px 20px 10px 0'}">
                        <router-link to="/admin/articleTag">
                            <a-button type="primary">
                                返回列表
                            </a-button>
                        </router-link>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="16" :offset="4" :style="{padding: '10px 24px 24px 24px'}">
                <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
                >
                    <a-form-model-item ref="title" label="标签名称" prop="title">
                        <a-input v-model="form.title"/>
                    </a-form-model-item>
                    <a-form-model-item label="所属网站" prop="website">
                        <a-select v-model="form.website" placeholder="请选择所属网站">
                            <a-select-option v-for="item in website" :key="item.uuid" :value="item.uuid">
                                {{ item.title }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                        <a-button type="primary" @click="onSubmit">
                            新建标签
                        </a-button>
                        <a-button style="margin-left: 10px;" @click="resetForm">
                            重置
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </a-col>
        </a-row>
    </div>
</template>

<script>
export default {
    name: "ArticleTagAdd",
    data() {
        return {
            labelCol: {span: 4},
            wrapperCol: {span: 14},
            form: {
                title: '',
                website: '',
            },
            website: [],
            rules: {
                title: [
                    {required: true, message: '标签标题必须输入', trigger: 'blur'},
                    {min: 2, max: 10, message: '标签标题在2-10个汉字长度范围', trigger: 'blur'},
                ],
                website: {required: true, message: '必须选择归属网站', trigger: 'change'},
            },
        };
    },
    methods: {
        getWebsite() {
            let that = this;
            this.$ajax.get(this.$host+"/admin/website/listAll", {
                params: {}
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.website = result.data;
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        addSuccess() {
            let that = this;
            this.$Modal.confirm({
                title: '添加文章标签成功',
                content: '已经成功添加名为：' + this.form.title + '的标签，点击确定跳转到标签列表',
                okText: '好的',
                okType: 'danger',
                cancelText: '继续添加',
                onOk() {
                    that.$router.push({path: "/admin/articleTag"});
                },
                onCancel() {
                    that.resetForm();
                },
            });
        },
        addCategory() {
            let that = this;
            this.$ajax.post(this.$host+"/admin/articleTag/add", that.form).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.addSuccess();
                } else {
                    that.$message.warn(result.msg);
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        onSubmit() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.addCategory();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
    mounted() {
        this.getWebsite();
    }
}
</script>

<style scoped>

</style>